<div class="filter-buttons">
  <button
    type="button"
    *ngFor="let filter of filters"
    [ngClass]="['btn', filter.id === activeFilter?.id ? selectedClass : '']"
    (click)="setActiveFilter($event, filter)"
  >
    {{ filter.title | translate }}
  </button>
</div>
